<template>
<div>
  <Grid name="filterGridSellinOperator" ref="filterGridSellinOperator" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"  v-bind:databound="dataBound"></Grid>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'Operator',
  extends: BaseFilter,
  components: {
    Grid
  },
  data() {
    return {
      fieldName: 'operator_id',
      fieldLabel: 'Operator',
      gridRef: 'filterGridSellinOperator',
      preload: [],
      schemaModelFields: {},
      url: 'sellin_operators',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'shipto',
        title: 'Shipto'
      }, {
        width: '160px',
        field: 'soldto',
        title: 'Soldto'
      }, {
        width: '160px',
        field: 'nif',
        title: 'NIF'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// SellinOperatorsFilter.vue?75b202f4